import { useHistory } from "react-router-dom";
import "./App.css";
// import Ham from './Ham/Ham';

import Routerpage from "./Pages/RouterPage";
import AuthRoute from "./Pages/AuthRoute";
import { useEffect, useState } from "react";
// import Ham from "./Ham/Ham";

function App() {
  let history = useHistory();

  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    checkAuth();
  }, []);
  const checkAuth = () => {
    const authToken = localStorage.getItem("disToken");
    if (authToken) {
      setIsLoggedIn(true);
      history.push("/");
    } else {
      history.push("/login");
    }
  };

  return (
    <>
      <div className="App">
        {isLoggedIn && <Routerpage />}
        {!isLoggedIn && <AuthRoute />}
        {/* <Ham/> */}
      </div>
    </>
  );
}

export default App;
